export var FeatureOptions = {
    activity: 'activity'
};
//# sourceMappingURL=activity-types.js.map